import React, { useEffect, useState } from 'react';
const headlines = ['„Damit Veränderung gelingt braucht es ein Verständnis der Erfolgsfaktoren des Wandels."', '„Die psychologische Seite der Veränderung wird oft unterschätzt."', '„Es sind die Mitarbeiter, die Veränderung mit Leben füllen."'];
interface FlipCardProps {
  frontTitle: string;
  backTitle: string;
  link: string;
}
const FlipCard: React.FC<FlipCardProps> = ({
  frontTitle,
  backTitle,
  link
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const handleClick = () => {
    window.location.href = link;
  };
  return <div className="relative w-full aspect-square cursor-pointer" style={{
    perspective: '1000px'
  }} onMouseEnter={() => setIsFlipped(true)} onMouseLeave={() => setIsFlipped(false)} onClick={handleClick} data-id="element-201">
      <div className="relative w-full h-full transition-transform duration-700" style={{
      transformStyle: 'preserve-3d',
      transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
    }} data-id="element-202">
        {/* Front */}
        <div className="absolute w-full h-full bg-white flex flex-col items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden'
      }} data-id="element-203">
          <div className="mb-4" data-id="element-204">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700" data-id="element-205">
              <polyline points="18 15 12 9 6 15" data-id="element-206"></polyline>
            </svg>
          </div>
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-207">
            {frontTitle}
          </h3>
        </div>

        {/* Back */}
        <div className="absolute w-full h-full bg-white flex items-center justify-center p-8" style={{
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        transform: 'rotateY(180deg)'
      }} data-id="element-208">
          <h3 className="text-xl text-orange-500 text-center font-normal" data-id="element-209">
            {backTitle}
          </h3>
        </div>
      </div>
    </div>;
};
export const ChangeBeratungPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-210">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-211">
          <div data-id="element-212">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '160px'
          }} data-id="element-213">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-214">
            <img src="https://cdn.magicpatterns.com/uploads/norn8JA7hMNJo9J9SahsJ9/Eva-Schifferer-Change_Beratung.png" alt="Change Beratung Strategie" className="max-h-80 object-contain" data-id="element-215" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-216">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-217">
          <div data-id="element-218">
            <p className="mb-6 text-base leading-relaxed" data-id="element-219">
              Veränderungsvorhaben in Organisationen haben oft keine gute
              Prognose. Dabei ist kontinuierliches Lernen und Veränderung in
              einem digitalen und agilen Umfeld mehr denn je gefragt.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-220">
              Am leichtesten lernen wir auf Basis unserer Stärken und
              Potenziale. Damit Veränderung gelingt braucht es ein Verständnis
              dieser Erfolgsfaktoren – sowohl kollektiv als auch individuell –
              sowie einen ganzheitlichen Ansatz, der Prozesse und Kommunikation
              mit berücksichtigt. Denn nur dann entsteht wirkliche Beteiligung
              und ein ehrlicher Dialog.
            </p>
          </div>
          <div data-id="element-221">
            <p className="mb-6 text-base leading-relaxed" data-id="element-222">
              Auf Basis meiner langjährigen Erfahrung in der Begleitung
              komplexer Veränderungen in sich schnell ändernden Branchen
              unterstütze ich Ihre Organisation in der Change Konzeption und
              Beratung, in der Teamentwicklung und als Coach.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-223">
              In Themen der Steuerung komplexer Transformationsprojekte arbeite
              ich eng mit einem Netzwerk an langjährigen und erfahrenen
              Kooperationspartnern zusammen.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-224">
          <FlipCard frontTitle="Konzeption und Umsetzung" backTitle="Erfolgsregeln für gelingende Veränderung" link="/change-beratung/konzeption-umsetzung" data-id="element-225" />
          <FlipCard frontTitle="Teamentwicklung" backTitle="Potenzial des Teams maximieren" link="/change-beratung/teamentwicklung" data-id="element-226" />
        </div>
      </section>
    </>;
};